module.exports = __webpack_public_path__ + "img/play.1ad9588e.png";